import React,{useState, useEffect}  from 'react';
import '../allpython/Pycss.css';
import { Card} from 'react-bootstrap';
import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Plist() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
    return (
         <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python List Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python list tutorial for beginners.python list is an item collection in a particular order.You can also create an empty list by assigning [] to a variable called newList" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python list sort,For python list,In python list,Python list append,Python list comprehensioni,Python list of functions,Python list functions,Python list length,
Python list len,Python list methods,Python list dictionaries,Python list operations,Python list loop,Python list commands,newlist,Python list to set,Python list example,Python list remove,Python list reverse" />
<link rel="canonical" href="https://www.codeexampler.com/python-list" />
</Helmet>

<div className='lg:pl-56'>

            <h1 className='m-4 mh1'>python list </h1>

            <div className="first">
        <a href="/python-lambda">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-list-method">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>



            <p className='mt-4 para'>1, python list is an item collection in a particular order.<br/>
            2, In Python list, is an order sequence of items in which we can store different data square brackets ([]) indicate a list and individual elements in the list separate by commas.<br/>
            3, You can also create an empty list by assigning [] to a variable called a new list.<br/>
            4, A list that contains no elements Known as an Empty list or New list.</p>

 


<h2 className='headings'>Python new list Syntax:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">newList</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-6">[</span>
                <span className="qwerty-6">]</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>



<h2 className='headings'>Python List example:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
          {"\n"}
                <span className="qwerty-4">newList</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-6">[</span>
                <span className="qwerty-6">]</span>
            {"\n"}
                <span className="qwerty-4">A</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-1">[</span>
                <span className="qwerty-2">16</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-3">2.2</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">car</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">]</span>
            {"\n"}
                <span className="qwerty-4">Fewnumbers</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-1">[</span>
                <span className="qwerty-2">16</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">2</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">8</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">20</span>
                <span className="qwerty-1">]</span>
            {"\n"}
                <span className="qwerty-4">friends</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-1">[</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">Anmol</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">Abhinav</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">Adarsh</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">]</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>    

<p className="bold para mt-4">If I asked you to write a few numbers,
you might write this in a simple manner<br/>
16,2,8,20<br/><br/>
But in Python, you’d write this:<br/> 
Fewnumbres=[16,2,8,20]
</p>
<h2 className="mt-4 mh2">The main point in the python list :</h2>
<p className="mt-4 para">1, Friends, Fewnumbers are the example of python lists. And all individual things inside items are known as items.<br/>
2, Lists are always enclosed in square brackets, and a comma always separates the objects contained within the list.<br/>
3, When a list create where the objects are assigned to a new list directly in your code (as shown above), Python programmers refer to this as a literal list<br/>
4, Creating a python list-we have already used them for numbers, strings, also both used together, and they can also be assigned a list<br/>
5,<span className="bold"> Imp thing in Python is that( everything is an object in Python).</span>
</p>
<h3 className="mt-4 mh3">Here’s a list of percentage %, which is a list of float:
</h3>
<br/>

<h2 className='headings'>Q-List of percentage % in Python example?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">Percentage</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-1">[</span>
                <span className="qwerty-8">1.6</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-8">0.2</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-8">0.8</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-8">2.0</span>
                <span className="qwerty-1">]</span>
                <span className="qwerty-10">  # all are objects seperated by commas and covered by a square brackets.</span>
                {"\n"} 
               <span className="qwerty-3">print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-4">Percentage</span>
                   <span className="qwerty-1">)</span>                 
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-1">[</span>
                          <span className="qwerty-2">1.6</span>
                          <span className="qwerty-6">,</span>
                          <span className="qwerty-2">0.2</span>
                          <span className="qwerty-6">,</span>
                          <span className="qwerty-2">0.8</span>
                          <span className="qwerty-6">,</span>
                          <span className="qwerty-2">2.0</span>
                          <span className="qwerty-1">]</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>  


<h2 className="mt-4 mh2">Mixed type in python list:</h2>
<p className="mt-4 para">Use many strings, many floats, and many integer values combine in a list. So they can be stored all types of values in a list.
</p>



<h2 className='headings'>Q-Mixed type python list example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">intro</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">anmol</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">choudhary</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">18</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">16.46</span>
                 <span className="qwerty-1">]</span>
                 {"\n"} 
                <span className="qwerty-3">print</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-4">intro</span>
                    <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                   <span className="qwerty-1">[</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">anmol</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">choudhary</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">18</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">16.46</span>
                 <span className="qwerty-1">]</span>
                           {"\n"}    
                           {"\n"}    
                 </code>
                   </pre>
                   </div> 


<h2 className="mt-4 mh2">Array in python list</h2>
<p className="mt-4 para">Getting items from a list using index no<br/>
if you can get single items or multiple items from a list using index no. list index start from 0 So <br/>
</p>




<h2 className='headings'>Python list index Example:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">vowels</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">a</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">e</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">i</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">o</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">u</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                 {"\n"} 
                <span className="qwerty-3">print</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-4">vowels</span>
                    <span className="qwerty-6">[</span>
                    <span className="qwerty-8">0</span>
                    <span className="qwerty-6">]</span>
                    <span className="qwerty-1">)</span>                 
                 {"\n"} 
                <span className="qwerty-3">print</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-4">vowels</span>
                    <span className="qwerty-6">[</span>
                    <span className="qwerty-8">0</span>
                    <span className="qwerty-1">:</span>                 
                    <span className="qwerty-8">3</span>
                    <span className="qwerty-6">]</span>
                    <span className="qwerty-1">)</span>                 
                 {"\n"} 
                <span className="qwerty-3">print</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-4">vowels</span>
                    <span className="qwerty-6">[</span>
                    <span className="qwerty-8">3</span>
                    <span className="qwerty-1">:</span>                 
                    <span className="qwerty-6">]</span>
                    <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                   <span className="qwerty-2">a</span>
                   {"\n"}
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">a</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">e</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">i</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                   {"\n"}
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">o</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">u</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                           {"\n"}    
                           {"\n"}    
                 </code>
                   </pre>
                   </div>  



<h2 className='headings'>Q-Why index position starts from 0, not 1 in Python List?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">Answer</span>
                <span className="qwerty-1"> - </span>
                <span className="qwerty-3">Because computers use binary digit orbits to store everything. You can get any element you can get any element you want from a list by</span>
            {"\n"}
                <span className="qwerty-3">         subtracting one from its position on the list. Binary counting starts at 0.</span>
                <span className="qwerty-3">to make efficient use of the bits and not waste any memory locations. </span>
            {"\n"}
                <span className="qwerty-2">         For example -</span>
                <span className="qwerty-3"> to access the third item in a list, you request index 2.</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>  


<h2 className="mt-4 mh2">Nested For Python list</h2>
<p className="mt-4 para">A list within another list is nested, and lists are mutable.</p>



<h2 className='headings'>Q-Write a Program Array Print Nested for Python list index?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">D</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Rathi</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-10">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">20</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">30</span>
                 <span className="qwerty-6">]</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">a</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                 {"\n"} 
                <span className="qwerty-3">print</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-4">D</span>
                    <span className="qwerty-1">)</span>                 
                 {"\n"} 
                <span className="qwerty-3">print</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-4">D</span>
                    <span className="qwerty-6">[</span>
                    <span className="qwerty-8">1</span>
                    <span className="qwerty-6">]</span>
                    <span className="qwerty-1">)</span>                 
                 {"\n"} 
                <span className="qwerty-3">print</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-4">D</span>
                    <span className="qwerty-6">[</span>
                    <span className="qwerty-8">0</span>
                    <span className="qwerty-6">]</span>
                    <span className="qwerty-1">)</span>                 
                 {"\n"} 
                <span className="qwerty-3">print</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-4">D</span>
                    <span className="qwerty-6">[</span>
                    <span className="qwerty-8">0</span>
                    <span className="qwerty-6">]</span>
                    <span className="qwerty-6">[</span>
                    <span className="qwerty-8">1</span>
                    <span className="qwerty-6">]</span>
                    <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                   <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">Rathi</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-8">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">20</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">30</span>
                 <span className="qwerty-6">]</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">a</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                   {"\n"}
                   <span className="qwerty-6">[</span>
                 <span className="qwerty-8">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">20</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">30</span>
                 <span className="qwerty-6">]</span>
                   {"\n"}
                   <span className="qwerty-2">Rathi</span>
                   {"\n"}
                   <span className="qwerty-2">a</span>
                           {"\n"}    
                           {"\n"}    
                 </code>
                   </pre>
                   </div>    


<h2 className="mt-4 mh2">Use in operator on the list:</h2>


<h2 className='headings'>Q-Write a Program Nested for Python list example?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
          {"\n"}
                 <span className="qwerty-4">Vowel</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">a</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">e</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">i</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">o</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">u</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>  
          {"\n"}
                 <span className="qwerty-6">if </span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-10">a</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-5"> in </span>
                 <span className="qwerty-4">Vowel</span>
                 <span className="qwerty-1"> :</span>
          {"\n"}
                 <span className="qwerty-3">   print</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-1">"</span>
                    <span className="qwerty-10">Present</span>
                    <span className="qwerty-1">"</span>
                    <span className="qwerty-1">)</span>                 
          {"\n"}
          <span className="qwerty-6">else </span>
                 <span className="qwerty-1">:</span>
          {"\n"}
                 <span className="qwerty-3">   print</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-1">"</span>
                    <span className="qwerty-10">Absent</span>
                    <span className="qwerty-1">"</span>
                    <span className="qwerty-1">)</span>                 
                 {"\n"} 
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                   <span className="qwerty-2">Present</span>
                   {"\n"}
                           {"\n"}    
                 </code>
                   </pre>
                   </div>





<h2 className='headings'>Q-Using Python for loop directly inside the list example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
           {"\n"}
                  <span className="qwerty-4">Name</span>
                  <span className="qwerty-1"> = </span>
                  <span className="qwerty-1">[</span>
                  <span className="qwerty-6">'</span>
                  <span className="qwerty-10">Ram</span>
                  <span className="qwerty-6">'</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">'</span>
                  <span className="qwerty-10">Lakshman</span>
                  <span className="qwerty-6">'</span>
                  <span className="qwerty-1">,</span>
                  <span className="qwerty-6">'</span>
                  <span className="qwerty-10">Bharat</span>
                  <span className="qwerty-6">'</span>
                  <span className="qwerty-1">]</span>  
           {"\n"}
                  <span className="qwerty-7">for </span>
                  <span className="qwerty-2">i</span>
                  <span className="qwerty-5"> in </span>
                  <span className="qwerty-4">Name</span>
                  <span className="qwerty-1"> :</span>
           {"\n"}
                  <span className="qwerty-3">   print</span>
                     <span className="qwerty-1">(</span>
                     <span className="qwerty-10">i</span>
                     <span className="qwerty-1">)</span>                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-3">Ram</span>
                    {"\n"}
                    <span className="qwerty-3">Lakshman</span>
                    {"\n"}
                    <span className="qwerty-3">Bharat</span>
                    {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 

      <h1 className="mt-5">  </h1>
      <div className="back">
        <a href="/python-lambda">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-list-method">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
</div>
    </div>
    )

}
export default Plist;